import { Link } from "react-router-dom";

export const article = [
  {
    articleId: 11,
    url: "suscribirse-a-mega-go",
    category: {
      slug:"comenzar",
      name: "Comenzar"
    },
    title: "Suscribirse a Mega GO",
    content: 
        <>
          <div className="row">
            <p>Para ver instrucciones detalladas sobre cómo suscribirte a Mega GO, 
              selecciona un dispositivo de la lista. Si aún no decidiste qué plan te gusta más,
              revisa los <Link to="/article/planes-y-precios">planes y precios</Link> que tenemos disponibles. Si tienes problemas para suscribirte
            a Mega GO o necesitas ayuda para elegir el plan, contáctanos.</p>
          </div>
          <div className="rowLine">
            <h2>Navegador web</h2>
            <ul className="decimal">
              <li>Visita <a href="https://megago.cl/" target="_blank" rel="noreferrer">megago.cl</a>. Haz click en Iniciar Sesión y luego en Regístrate.</li>
              <li>Escribe tu dirección de correo electrónico y una contraseña.</li>
              <li>Se te solicitará aceptar los Términos y Condiciones y luego debes pinchar Regístrate.</li>
              <li>Al registrarte, en forma automática tendrás acceso al plan gratuito y podrás acceder al contenido liberado.</li>
              <li>Si eliges algún contenido que se encuentra sólo disponible en el plan full (con un candado en la parte 
                superior derecha), se te abrirá una ventana con la opción de suscribirte al plan full, 
                derivándote a la sección de medio de pago para ello. </li>
            </ul>
          </div>
          <div className="rowLine">
            <h2>Dispositivo móvil</h2>
            <div className="accordeonContent">
              <ul className="decimal">
                <li>En tu dispositivo móvil: 
                  <ul className="disc">
                    <li>Ve a la App Store de Apple o a la Google Play Store</li>
                    <li>Descarga la aplicación de Mega GO</li>
                  </ul>
                </li>
                <li>Abre la aplicación de Mega GO </li>
                <li>Selecciona Prueba ahora.</li>
                <li>Escribe tu dirección de correo electrónico y una contraseña.</li>
                <li>Se te solicitará aceptar los Términos y Condiciones y luego debes pinchar Regístrate.</li>
                <li>Al registrarte, en forma automática tendrás acceso al plan gratuito y podrás acceder al contenido liberado. </li>
                <li>Si eliges algún contenido que se encuentra sólo disponible en el plan full (con un candado en la parte superior derecha), se te abrirá una ventana con la opción de suscribirte al plan full, derivándote a la sección de medio de pago para ello. </li>
              </ul>
            </div>
          </div>
          <div>
            <h2>Smart TV o dispositivo conectado a la TV</h2>
              <ul className="decimal">
                <li>En el dispositivo conectado a la TV:
                  <ul className="disc">
                    <li>Ve a la tienda de aplicaciones</li>
                    <li>Descarga la aplicación de Mega GO</li>
                  </ul>
                </li>
                <li>Abre la aplicación de Mega GO </li>
                <li>Selecciona Prueba ahora.</li>
                <li>En una PC o dispositivo móvil:
                  <ul className="disc">
                    <li>Visita la URL que se muestra en pantalla</li>
                    <li>O escanea el código QR</li>
                    <li>Sigue las instrucciones</li>
                  </ul>
                </li>
                <li>Al registrarte, en forma automática tendrás acceso al plan gratuito y podrás acceder al contenido liberado. </li>
                <li>Si eliges algún contenido que se encuentra sólo disponible en el plan full (con un candado en la parte superior derecha), se te desplegará una URL y un código QR que podrás escanear para realizar el proceso de suscripción.</li>
              </ul>
          </div>
        </>
  }
];